import { getSearchParamsLocalStorage } from 'lib/storage'
import { getValidFiltersFromUrl } from './utils'
import { DEFAULT_FILTERS, FILTERS_STATE, FILTER_OPTIONS } from './constants'

const location = typeof globalThis.window === 'undefined' ? null : globalThis.window.location
const { filters: localFilters } = getSearchParamsLocalStorage()

const validFilters = getValidFiltersFromUrl(location?.search)

const filtersFromUrl = FILTER_OPTIONS.reduce<Record<string, string | string[]>>(
  (result, currentFilter) => {
    const validCurrentFilter = validFilters[currentFilter]

    if (!validCurrentFilter) {
      return result
    }

    /* eslint-disable-next-line no-param-reassign */
    result[currentFilter] = validFilters[currentFilter]

    if (
      ['facilities', 'stars', 'accommodationTypes', 'ratings', 'themes', 'boards'].includes(
        currentFilter
      )
    ) {
      /* eslint-disable-next-line no-param-reassign */
      result[currentFilter] = validFilters[currentFilter].split(',')

      return result
    }

    return result
  },
  {}
)

export type FiltersState = {
  family?: boolean
  facilities?: string[]
  orderBy: string
  stars?: string[]
  ratings?: string[]
  accommodationTypes?: string[]
  minPrice?: string
  maxPrice?: string
  themes?: string[]
  boards?: string[]
}

const state: Record<typeof FILTERS_STATE, FiltersState> = {
  [FILTERS_STATE]: {
    ...DEFAULT_FILTERS,
    ...localFilters,
    ...filtersFromUrl,
  },
}

export default state
